module.exports = __webpack_public_path__ + "static/img/1692694612409.aab5ee5a.jpg";